import React, {Component} from "react";
import {Card, CardBody, Col, Row} from "reactstrap";

import moment from 'moment-es6'

import {secondsToMinutes} from "../../../services/time/time-service";
import {weeks} from "../../../services/date/date-service";

import FormSection from "../form-section/form-section";

class PlayerActivitiesSummaryCard extends Component {
    render() {
        return <div className="mp-0 container-fluid">        
            <FormSection
                sectionLabel="Session Summary"
                component={this.minutesPlayedCard()}
            />
        </div>
    };

    weeksMinutesDifference = () => {
        const {results} = this.props;

        let previousWeek = weeks(2)[1];

        const previousWeekResults = results.filter(result => {
            return moment(result._created).isSameOrBefore(previousWeek[0]) &&
                moment(result._created).isSameOrAfter(previousWeek.slice(-1)[0])
        });
        const minutesPlayedPreviousWeek = minutesPlayed(previousWeekResults);
        const averageMinutesPlayedPreviousWeek = previousWeekResults.length !== 0 &&
            Math.round((minutesPlayedPreviousWeek / previousWeekResults.length) * 100) / 100;

        let currentWeek = weeks(1)[0];
        const currentWeekResults = results.filter(result => {
            return moment(result._created).isSameOrBefore(currentWeek[0]) &&
                moment(result._created).isSameOrAfter(currentWeek.slice(-1)[0])
        });
        const minutesPlayedCurrentWeek = minutesPlayed(currentWeekResults);
        const averageMinutesPlayedCurrentWeek = currentWeekResults.length !== 0 &&
            Math.round((minutesPlayedCurrentWeek / currentWeekResults.length) * 100) / 100;

        let percentageDifference = 0;
        if (!!minutesPlayedPreviousWeek && !!minutesPlayedCurrentWeek) {
            percentageDifference = Math.round((minutesPlayedCurrentWeek - minutesPlayedPreviousWeek) / minutesPlayedCurrentWeek * 100);
            if (percentageDifference > 500 || percentageDifference < -500) {
                percentageDifference = 0
            }
        }

        let averagePlayedPercentageDifference = 0;
        if (!!averageMinutesPlayedPreviousWeek && !!averageMinutesPlayedCurrentWeek) {
            averagePlayedPercentageDifference = Math.round((averageMinutesPlayedCurrentWeek - averageMinutesPlayedPreviousWeek) / averageMinutesPlayedCurrentWeek * 100);
            if (averagePlayedPercentageDifference > 1000 || averagePlayedPercentageDifference < -1000) {
                averagePlayedPercentageDifference = 0
            }
        }

        const averagePlayedTitleText = `Previous Week: ${averageMinutesPlayedPreviousWeek} min/game, Current Week: ${averageMinutesPlayedCurrentWeek} min/game`;
        const titleText = `Previous Week: ${minutesPlayedPreviousWeek} min, Current Week: ${minutesPlayedCurrentWeek} min`;

        return {
            percentageDifference, minutesPlayedPreviousWeek, minutesPlayedCurrentWeek, titleText,
            averagePlayedPercentageDifference, averageMinutesPlayedPreviousWeek, averageMinutesPlayedCurrentWeek,
            averagePlayedTitleText
        }
    };

    minutesPlayedCard = () => {
        const {results, small} = this.props;
        const _minutesPlayed = minutesPlayed(results);

        const minutesDifferences = this.weeksMinutesDifference();
        const isMinutesPlayedDifferencePositive = minutesDifferences.percentageDifference > 0;
        const isAveragePlayedDifferencePositive = minutesDifferences.averagePlayedPercentageDifference > 0;

        const _averageGameDuration = Math.round((_minutesPlayed / results.length) * 100) / 100;

        return (
            <Card className="mp-0 border-0 container-fluid">
                <CardBody className="mp-0 container-fluid">
                    <Row className="mp-0">
                        <Col md={6} className="m-0 pl-3 py-1"
                             title={minutesDifferences.percentageDifference !== 0 ? minutesDifferences.titleText : ""}>
                            <Row className="m-0 px-2 py-1 text-left border-right">
                                {!small
                                    ? <h3 className="mb-0 pb-0">{_minutesPlayed}</h3>
                                    : <h6 className="mb-0 pb-0">
                                        {_minutesPlayed}
                                        <span className="ml-1 my-0 p-0 very-small secondary-color">Minutes Played</span>
                                    </h6>

                                }
                                {!small && minutesDifferences.percentageDifference !== 0 &&
                                <icon
                                    className={`ml-2 mr-1 fa fa-caret-${isMinutesPlayedDifferencePositive ? "up" : "down"}`}
                                    style={isMinutesPlayedDifferencePositive
                                        ? {color: "#3DFF73"}
                                        : {color: "#F04C58"}
                                    }/>
                                }
                                {!small && minutesDifferences.percentageDifference !== 0 &&
                                <p className="mb-0 pb-0 very-small" style={isMinutesPlayedDifferencePositive
                                    ? {color: "#3DFF73"}
                                    : {color: "#F04C58"}
                                }>
                                    {Math.abs(minutesDifferences.percentageDifference)}%</p>
                                }
                            </Row>
                            {!small &&
                            <Row className="mp-0 border-right">
                                <p className="mp-0 small secondary-color">Minutes Played</p>
                            </Row>
                            }
                        </Col>
                        <Col md={6} className="m-0 pl-3 py-1"
                             title={minutesDifferences.averagePlayedPercentageDifference !== 0 ? minutesDifferences.averagePlayedTitleText : ""}>
                            <Row className="m-0 px-2 py-1 text-left">
                                {!small
                                    ? <h3 className="mb-0 pb-0">{_averageGameDuration || 0}<span
                                        className="very-small">min</span>
                                    </h3>
                                    : <h6 className="mb-0 pb-0">
                                        {_averageGameDuration || 0}
                                        <span
                                            className="ml-1 my-0 p-0 very-small secondary-color">Avg. Activity Duration</span>
                                    </h6>
                                }

                                {!small && minutesDifferences.averagePlayedPercentageDifference !== 0 &&
                                <icon
                                    className={`ml-2 mr-1 fa fa-caret-${isAveragePlayedDifferencePositive ? "up" : "down"}`}
                                    style={isMinutesPlayedDifferencePositive
                                        ? {color: "#3DFF73"}
                                        : {color: "#F04C58"}
                                    }
                                />
                                }
                                {!small && minutesDifferences.averagePlayedPercentageDifference !== 0 &&
                                <p className="mb-0 pb-0 very-small" style={isAveragePlayedDifferencePositive
                                    ? {color: "#3DFF73"}
                                    : {color: "#F04C58"}
                                }>
                                    {Math.abs(minutesDifferences.averagePlayedPercentageDifference)}%</p>
                                }
                            </Row>
                            {!small &&
                            <Row className="mp-0">
                                <p className="mp-0 small secondary-color">Avg. Activity Duration</p>
                            </Row>
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    }
}

const minutesPlayed = (results) => {
    if (!results || results.length === 0) {
        return 0
    }

    const seconds = results.reduce((total, result) => {
        return total + result.duration
    }, 0);


    return secondsToMinutes(seconds)
};

export default PlayerActivitiesSummaryCard;



// WEBPACK FOOTER //
// ./src/components/components/player-activities-summary-card/player-activities-summary-card.js